import { CLIENTS } from "@/lib/data";

export const ClientMarquee = () => (
  <section className="relative border-y border-[var(--border-subtle)] py-8 overflow-hidden marquee-pause">
    <div className="flex w-max animate-marquee">
      {[...CLIENTS, ...CLIENTS].map((c, i) => (
        <div key={i} className="flex items-center gap-16 px-8">
          <span className="font-display text-2xl sm:text-3xl font-bold text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors whitespace-nowrap">
            {c}
          </span>
          <span className="text-[var(--accent-primary)]">✦</span>
        </div>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--bg-primary)] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--bg-primary)] to-transparent" />
  </section>
);
